import React from 'react';
import PropTypes from 'prop-types';
import {Document, Page, setOptions} from 'react-pdf/build/entry.webpack';
import withStyles from 'material-ui/styles/withStyles';
import Loading from '../../../common/with-loading-indicator/indicator';

setOptions({
	cMapUrl: 'cmaps/',
	cMapPacked: true
});

const styles = () => ({
	page: {
		display: 'flex',
		flexFlow: 'column',
		alignItems: 'center',
		'@global div.ReactPDF__Page__textContent': {
			display: 'none!important'
		}
	}
});

const PDFViewer = ({
	url, width, numPages, classes, onDocumentLoadSuccess
}) => (
	<Document
		file={url}
		noData={(<Loading absolutelyCentered/>)}
		loading={(<Loading absolutelyCentered/>)}
		onLoadSuccess={onDocumentLoadSuccess}
	>
		{Array.from(new Array(numPages),
			(el, index) => (
				<Page
					renderAnnotations={false}
					className={classes.page}
					key={`page_${index + 1}`}
					pageNumber={index + 1}
					width={width}
				/>
			),
		)}
	</Document>
);

PDFViewer.propTypes = {
	url: PropTypes.string,
	width: PropTypes.number.isRequired,
	numPages: PropTypes.number.isRequired,
	classes: PropTypes.object.isRequired,
	onDocumentLoadSuccess: PropTypes.func
};

export default withStyles(styles)(PDFViewer);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer/pdf-viewer.jsx